//hooks
import UseUserPasskeyInformation from './UserPasskeyInformation.hooks';

//components
import { LoadingSpinner } from 'thrive-components';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import IPWhitelist from  '@/components/elements/orgSettings/passkeys/whitelist/IPWhitelist';
import PasskeySetUpNeededPanel from  '@/components/elements/orgSettings/passkeys/PasskeySetUpNeededPanel';
import RegisteredPasskeysData from  '@/components/elements/orgSettings/passkeys/RegisteredPasskeysData';
import AccountRecoveryCodes from  '@/components/elements/orgSettings/passkeys/recovery/AccountRecoveryCodes';
import RecoveryRequestPanel from  '@/components/elements/orgSettings/passkeys/recovery/RecoveryRequestPanel';
import RecoveryRequestsModal from  '@/components/modals/orgSettings/Passkeys/Recovery/RecoveryRequestsModal';
import CreateCodeModal from  '@/components/modals/orgSettings/Passkeys/CreateCode/CreateCodeModal';
import RevokeCodeModal from  '@/components/modals/orgSettings/Passkeys/RevokeCodeModal';
import RemoveIpAddressModal from  '@/components/modals/orgSettings/Passkeys/RemoveIpAddressModal';
import WhitelistRestrictionModal from  '@/components/modals/orgSettings/Passkeys/Whitelist/WhitelistRestrictionModal';
import WhitelistAddressModal from  '@/components/modals/orgSettings/Passkeys/Whitelist/WhitelistAddressModal';

//styling
import "../../../../../css/orgSettings/users/user-passkey-information.scss";



const UserPasskeyInformation = () => {  
    const {
        setUpCompleted,
        restrictedAccess,
        notificationDetails,
        whitelistIsEnabled,
        whitelistTableContent,
        passkeyTableContent,
        recoveryCodesTableContent,
        canCreateRecoveryCode,
        showRequestPanel,
        showRecoveryRequestsModal,
        showCreateCodeModal,
        showRevokeModal,
        removeIpId,
        showRestrictionModal,
        showWhitelistAddressModal,
        whitelistData,
        passkeysEnabled,
        isViewingPersonalAccount,
        refreshRecoveryCodes,
        setShowWhitelistAddressModal,
        setShowRestrictionModal,
        onRestrictWhitelistClick,
        setRemoveIpId, 
        setShowRevokeModal,
        onRevokeCodeConfirmClick,
        setShowCreateCodeModal,
        setShowRecoveryRequestsModal,
        onAddWhitelistAddress,
        onRemoveWhitelistAddress
    } = UseUserPasskeyInformation();



    if (!setUpCompleted) {
        return (
            <div className='loading-passkey-data-spinner' data-testid="user-passkey-information">
                <LoadingSpinner size={10} />
            </div>
        )

    }
    
    return ( 
        <div className="user-passkey-information" data-testid="user-passkey-information">
            {restrictedAccess
                ?   <PasskeySetUpNeededPanel />

                :   (passkeysEnabled && (
                        <>
                        <RegisteredPasskeysData 
                            registeredPasskeysTableContent={passkeyTableContent}
                        />

                        {showRequestPanel &&
                            <RecoveryRequestPanel 
                                onViewRequestsClick={()=> setShowRecoveryRequestsModal(true)}
                            />         
                        }
                        
                        {!isViewingPersonalAccount &&
                            <AccountRecoveryCodes 
                                recoveryCodesTableContent={recoveryCodesTableContent}
                            />
                        }
                                
                        <IPWhitelist 
                            whitelistEnabled={whitelistIsEnabled} 
                            whitelistTableContent={whitelistTableContent} 
                            onRemoveRestrictionClick={()=>setShowRestrictionModal(true)} 
                            canViewRequests={!isViewingPersonalAccount}
                            onViewRequests={()=> setShowRecoveryRequestsModal(true)} 
                            onAddWhitelistAddress={()=>setShowWhitelistAddressModal(true)} 
                            onEnableWhitelistClick={()=>setShowRestrictionModal(true)} 
                            onCreateCodeClick={()=>setShowCreateCodeModal(true)}
                            canCreateRecoveryCode = { canCreateRecoveryCode } 
                        />

        

                        
                        </>
                    )
                )
            }

            {notificationDetails && 
                (
                    <NotificationBar 
                        show={notificationDetails?.show} 
                        notificationStatus={notificationDetails?.status} 
                        msg={notificationDetails?.message} 
                    />
                )
            }

            <RecoveryRequestsModal 
                showModal={showRecoveryRequestsModal}
                hideModal={() => setShowRecoveryRequestsModal(false)}
            />

            <CreateCodeModal 
                showModal={showCreateCodeModal}
                hideModal={() => setShowCreateCodeModal(false)}
                onGenerateClick={refreshRecoveryCodes}
            />

            <RevokeCodeModal
                showModal={showRevokeModal}
                onConfirmClick={onRevokeCodeConfirmClick}
                hideModal={()=>setShowRevokeModal(false)}
            />

            <RemoveIpAddressModal
                showModal={!!removeIpId}
                onConfirmClick={() => onRemoveWhitelistAddress()}
                hideModal={()=>setRemoveIpId(null)}
            />

            <WhitelistRestrictionModal
                whitelistIsEnabled={whitelistIsEnabled}
                showModal={showRestrictionModal}
                onConfirmClick={() =>onRestrictWhitelistClick()}
                hideModal={()=>setShowRestrictionModal(false)}
            />

            <WhitelistAddressModal
                showModal={showWhitelistAddressModal}
                hideModal={() => setShowWhitelistAddressModal(false)}
                onAddAddress={onAddWhitelistAddress}
                onRemoveClick={onRemoveWhitelistAddress}
                whitelistData={whitelistData}
            />
        </div>
    )
}

export default UserPasskeyInformation